module.exports = __webpack_public_path__ + "static/media/successMovePorto.602a930c.svg";